
import ApiService from '../base/api_service';

export const getSellingUpdate = async (accessToken, params) => {
    try {
        const response = await ApiService.get('/selling-updates', {
            params: params,
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const showSellingUpdate = async (accessToken, id) => {
    try {
        const response = await ApiService.get(`/selling-update/show/${id}`, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const postSellingUpdate = async (accessToken, data) => {
    try {
        const response = await ApiService.post('/selling-update/create', data, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const updateSellingUpdate = async (accessToken, id, data) => {
    try {
        const response = await ApiService.post(`/selling-update/update/${id}`, data, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}